import * as types from './actionTypes';

const initialState = {
  payrollAllowances: [],
  allowanceOptions: [],
  loading: false,
  error: null,
  success: false,
  importedData: [],
};

const payrollAllowanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_PAYROLL_ALLOWANCE_REQUEST:
    case types.SAVE_PAYROLL_ALLOWANCE_REQUEST:
    case types.REMOVE_PAYROLL_ALLOWANCE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case types.FETCH_PAYROLL_ALLOWANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        payrollAllowances: (action?.payload).map(ded => ({
          enable_status: true,
          entry_type: 1,
          pay_allow_id: ded.pay_allow_id,
          emp_code: ded.emp_no,
          emp_no: { value: ded.emp_id, label: ded.emp_no + ' - ' + ded.emp_name },
          emp_id: ded.emp_id,
          emp_name: ded.emp_name,
          amount: ded.amount,
          remarks: ded.remarks
        })),
      };

    case types.SAVE_PAYROLL_ALLOWANCE_SUCCESS:
    case types.REMOVE_PAYROLL_ALLOWANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };

    case types.FETCH_PAYROLL_ALLOWANCE_FAILURE:
    case types.SAVE_PAYROLL_ALLOWANCE_FAILURE:
    case types.REMOVE_PAYROLL_ALLOWANCE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case types.FETCH_PAYROLL_ALLOWANCES_DROPDOWN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false,
      };

    case types.FETCH_PAYROLL_ALLOWANCES_DROPDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        allowanceOptions: action.payload,
        success: false,
      };

    case types.FETCH_PAYROLL_ALLOWANCES_DROPDOWN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false,
      };

    case types.FETCH_PAYROLL_ALLOWANCES_TEMPLATE_REQUEST:
    case types.FETCH_PAYROLL_ALLOWANCES_TEMPLATE_SUCCESS:
      return { ...state, loading: false, success: false, template: action.payload };
    case types.FETCH_PAYROLL_ALLOWANCES_TEMPLATE_FAILURE:

    case types.PAYROLL_DEDUCTION_ALLOWANCE_IMPORT:
    case types.PAYROLL_DEDUCTION_ALLOWANCE_IMPORT_SUCCESS:
      return { ...state, loading: false, success: true, importedData: action.payload?.data || [] };
    case types.PAYROLL_DEDUCTION_ALLOWANCE_IMPORT_FAILURE:

    case types.RESET_SAVE_STATUS:
      return {
        ...state,
        success: false,
        importedData: [],
      };
    default:
      return state;
  }
};

export default payrollAllowanceReducer;
